import type { HTMLAttributeAnchorTarget } from 'react';
import React from 'react';
import { useIntl } from 'react-intl';

import { Box } from '@/components/Box';
import LinkWithLocale from '@/components/LinkWithLocale/LinkWithLocale';
import { Modal } from '@/components/Modal';
import { SectionHeader } from '@/components/SectionHeader';
import { Typography } from '@/components/Typography';
import { paths } from '@/lib/paths';
import { pdpMessages } from '@/messages/product';

export interface WaterResistanceModalProps {
  learnMoreLinkTarget?: HTMLAttributeAnchorTarget;
  onClose: () => void;
  openModal: boolean;
  waterResistanceData: string;
  waterResistanceTextComputed: string;
}

const WaterResistanceModal: React.FC<WaterResistanceModalProps> = ({
  learnMoreLinkTarget,
  onClose,
  openModal,
  waterResistanceData,
  waterResistanceTextComputed,
}) => {
  const { formatMessage } = useIntl();

  return (
    <Modal
      data-test-id='WaterResistanceModal'
      gutters={false}
      isOpen={openModal}
      maxWidth='xs'
      onClose={onClose}
    >
      <Modal.Header
        data-test-id='WaterResistanceModalHeader'
        divider
        onClose={onClose}
      >
        <SectionHeader
          numberOfColoredWords={0}
          sizeDesktop={30}
          sizeMobile={24}
          text={waterResistanceData}
        />
      </Modal.Header>
      <Modal.Body data-test-id='WaterResistanceModalBody'>
        <Box marginTop={2} paddingX={4} paddingY={2}>
          <Typography
            data-test-id='WaterResistanceModalTypography'
            scale='p2'
            textAlign='start'
          >
            {waterResistanceTextComputed}
          </Typography>
        </Box>
      </Modal.Body>
      <Modal.Footer
        data-test-id='WaterResistanceModalFooter'
        isFullWidthMobile={false}
      >
        <Box marginTop={1}>
          <LinkWithLocale
            href={paths.service.resistance.url()}
            target={learnMoreLinkTarget}
          >
            <Typography color='primary' scale='p2' textAlign='center'>
              <span
                data-test-id='WaterResistanceModalSpan'
                style={{ textDecoration: 'underline', cursor: 'pointer' }}
              >
                {formatMessage(pdpMessages.learnMore)}
              </span>
            </Typography>
          </LinkWithLocale>
        </Box>
      </Modal.Footer>
    </Modal>
  );
};

export default WaterResistanceModal;
